import { render } from "./TabAttivitaImport.vue?vue&type=template&id=a98a8310&scoped=true"
import script from "./TabAttivitaImport.vue?vue&type=script&lang=js"
export * from "./TabAttivitaImport.vue?vue&type=script&lang=js"

import "./TabAttivitaImport.vue?vue&type=style&index=0&id=a98a8310&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98a8310"]])

export default __exports__